export default __webpack_public_path__ + "static/engageFeatureHome-f7fb32dc9187652a94fc9af6cfd93868.svg";